<template>
  <el-form>
    <h2>Welcome back</h2>

    <el-form-item label="Email address" required>
      <el-input v-model="form.email" placeholder="Enter your email address" />
    </el-form-item>

    <el-form-item v-if="!forgot" label="Password" :error="error" required>
      <el-input
        v-model="form.password"
        type="password"
        placeholder="Enter password"
      />
    </el-form-item>

    <vue-recaptcha
      ref="recaptcha"
      class="recaptcha"
      :sitekey="$root.recaptchaKey"
      :loadRecaptchaScript="true"
      @verify="verify"
      @expired="expired"
    />

    <el-button
      v-if="forgot"
      type="primary"
      :loading="loading"
      :disabled="!form['g-recaptcha-response']"
      @click.prevent="reset"
    >
      Reset your password
    </el-button>

    <template v-else>
      <el-button
        type="text"
        class="forgot"
        @click="forgot = true"
      >
        Forgot password?
      </el-button>

      <el-button
        type="primary"
        :loading="loading"
        :disabled="!form['g-recaptcha-response']"
        @click.prevent="login"
      >
        Log in
      </el-button>
    </template>
  </el-form>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {
    VueRecaptcha
  },
  data () {
    return {
      loading: false,
      forgot: false,
      error: null,
      form: {
        email: null,
        password: null
      }
    }
  },
  methods: {
    login () {
      this.loading = true
      this.$store.dispatch('login', this.form).catch(() => {
        this.loading = false
        this.error = 'Your email or password is incorrect. Please check, and try again.'
        this.$refs.recaptcha.reset()
      })
    },
    reset () {
      this.loading = true
      this.$store.dispatch('resetAccount', this.form).then(() => {
        this.loading = false
        this.$notify({
          type: 'success',
          title: 'Reset password',
          message: 'If your email is registered, you will receive an email to reset your password',
          position: 'bottom-left'
        })
      })
    },
    verify (recaptcha) {
      this.$set(this.form, 'g-recaptcha-response', recaptcha)
    },
    expired () {
      this.form['g-recaptcha-response'] = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .forgot {
    float: right;
  }

  .el-button + .el-button {
    margin-left: 0;
  }

  .recaptcha {
    margin: 30px 0 15px;
  }
</style>
